import * as Yup from 'yup'

import { file } from 'utils/yup'

export const OWNER_STEP_ONE_SCHEMA = Yup.object().shape({
  fileOne: file,
  fileTwo: file,
})

export const OWNER_STEP_TWO_SCHEMA = Yup.object().shape({
  fileThree: file,
})

export const OWNER_SUBMIT_SCHEMA = Yup.object().shape({
  fileOne: file,
  fileTwo: file,
  fileThree: file,
})
